import { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import ApiService from '@services/api';

export function useSession() {
  const { token } = useParams<{ token?: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMigrating, setIsMigrating] = useState(!!token);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function migrateToken() {
      if (!token) {
        setIsMigrating(false);
        return;
      }

      try {
        const { api } = new ApiService(token);
        await api.post('/auth/session', { token });

        // Success! Remove the token from URL
        const cleanPath = location.pathname.replace(`/${token}`, '');
        navigate(cleanPath, { replace: true });
      } catch (err) {
        console.error('Failed to migrate token to session', err);
        setError('Falha na autenticação da sessão');
      } finally {
        setIsMigrating(false);
      }
    }

    migrateToken();
  }, [token, navigate, location.pathname]);

  return { isMigrating, error };
}
